import { SERVER_URL } from "./config";

const groupNames = ["group-1", "group-2"];

function formatDate(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('-');
}

const gdalaGroupInfo = {
  "group-1": [
    {
      label: "Vehicle No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "vehicle_no",
      type: "text",
      placeHolder: "1234",
      apiConfigKey: "getVehicleSuggestions",
      url: SERVER_URL + "/vehicle/",
      suggestionKeyword: "vehicle_no",
      suggestionKeywordForFetchApiArgs: "vehicle_no",
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
        tds_rate: "tds_rate",
      },
      suggestionChooseQueryKeyword: "vehicle_no",
      apiCallRequiredOnGetValue: true,
      keyboardNavigationMap: {
        Enter: "station_from_name",
      },
      toValidate: true,
      valueVerificationFromSuggestionNeeded: true,
      valueVerificationCompulsionField: "vehicle_id",
    },
    {
      label: "Station From",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_from_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "station_from",
        name: "station_from_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "station_to_name",
      },
    },
    {
      label: "Station To",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_to_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "station_to",
        name: "station_to_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "amount",
      },
    },
    {
      label: "Amount",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "amount",
      type: "text",
      placeHolder: "",
      toValidate: false,
      isNumericValue: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "advance_bhada",
      },
    },
    {
      label: "Advance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "advance_bhada",
      type: "text",
      placeHolder: "",
      toValidate: false,
      isNumericValue: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "owner_name",
      },
    },
    {
      label: "Balance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "balance_bhada",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "net_balance",
      },
    },
    {
      label: "Net Balance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "net_balance",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "owner_name",
      },
    },
  ],
  "group-2": [
    {
      label: "Owner Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "owner_name",
      type: "text",
      placeHolder: "",
      // url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
      },
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "driver_name",
      },
    },
    {
      label: "Driver Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "driver_name",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
      },
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "remarks",
      },
    },
    {
      label: "Remarks",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "remarks",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "payable_branch_name",
      },
    },
    {
      label: "Payable Branch",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "payable_branch_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "payable_branch",
        name: "payable_branch_name",
      },
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "challan_no",
      },
    },
    {
      label: "Paid At",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "bhada_paid_branch_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "payable_branch",
        name: "payable_branch_name",
      },
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "challan_no",
      },
    },
  ],
};

const xpressGroupInfo = {
  "group-1": [
    {
      label: "Vehicle No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "vehicle_no",
      type: "text",
      placeHolder: "1234",
      apiConfigKey: "getVehicleSuggestions",
      url: SERVER_URL + "/vehicle/",
      suggestionKeyword: "vehicle_no",
      suggestionKeywordForFetchApiArgs: "vehicle_no",
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
        tds_rate: "tds_rate",
      },
      suggestionChooseQueryKeyword: "vehicle_no",
      apiCallRequiredOnGetValue: true,
      keyboardNavigationMap: {
        Enter: "station_from_name",
      },
      toValidate: true,
      valueVerificationFromSuggestionNeeded: true,
      valueVerificationCompulsionField: "vehicle_id",
    },
    {
      label: "Station From",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_from_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "station_from",
        name: "station_from_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "station_to_name",
      },
    },
    {
      label: "Station To",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_to_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "station_to",
        name: "station_to_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "amount",
      },
    },
    {
      label: "Amount",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "amount",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "extra_charge",
      },
    },
    {
      label: "Extra Charge",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "extra_charge",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "detention_charge",
      },
    },
    {
      label: "Detention Charge",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "detention_charge",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "shortage_charge",
      },
    },
    {
      label: "Shortage Charge",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "shortage_charge",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "other_deduction_charge",
      },
    },
    {
      label: "Other Deduction Charge",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "other_deduction_charge",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "advance_bhada",
      },
    },
    {
      label: "Advance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "advance_bhada",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "billing_party_name",
      },
    },
    {
      label: "Balance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "balance_bhada",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "tds_amount",
      },
    },
    {
      label: "Tds Amount",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "tds_amount",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "net_balance",
      },
    },
    {
      label: "Net Balance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "net_balance",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "owner_name",
      },
    },
  ],
  "group-2": [
    {
      label: "Billing Party",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "billing_party_name",
      placeHolder: "",
      type: "text",
      apiConfigKey: "getConsigneeSuggestions",
      url: SERVER_URL + "/consignee/",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionKeyword: "consignee_name",
      suggestionChooseQueryKeyword: "billing_party",
      suggestionSchema: {
        consignee_name: "billing_party_name",
        consignee_id: "billing_party",
      },
      keyboardNavigationMap: {
        Enter: "owner_name",
      },
      valueVerificationFromSuggestionNeeded: true,
      valueVerificationCompulsionField: "billing_party",
    //   idClearanceNeeded: "billing_party"
    },
    {
      label: "Owner Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "owner_name",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "pan_no",
      },
    },
    {
      label: "Pan Card No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "pan_no",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "driver_name",
      },
    },
    {
      label: "Driver Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "driver_name",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
      },
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "remarks",
      },
    },
    {
      label: "Remarks",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "remarks",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "payable_branch_name",
      },
    },
    {
      label: "Payable Branch",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "payable_branch_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "payable_branch",
        name: "payable_branch_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "challan_no",
      },
    },
    {
      label: "Paid At",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "bhada_paid_branch_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "payable_branch",
        name: "payable_branch_name",
      },
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "challan_no",
      },
    },
  ],
};

const guruGroupInfo = {
  "group-1": [
    {
      label: "Vehicle No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "vehicle_no",
      type: "text",
      placeHolder: "1234",
      apiConfigKey: "getVehicleSuggestions",
      url: SERVER_URL + "/vehicle/",
      suggestionKeyword: "vehicle_no",
      suggestionKeywordForFetchApiArgs: "vehicle_no",
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
        tds_rate: "tds_rate",
        owner_no:"owner_no",
        driver_no:"driver_no",
        license_no:"license_no",
      },
      suggestionChooseQueryKeyword: "vehicle_no",
      apiCallRequiredOnGetValue: true,
      keyboardNavigationMap: {
        Enter: "station_from_name",
      },
      toValidate: true,
      valueVerificationFromSuggestionNeeded: true,
      valueVerificationCompulsionField: "vehicle_id",
    },
    {
      label: "Station From",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_from_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "station_from",
        name: "station_from_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "station_to_name",
      },
    },
    {
      label: "Station To",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_to_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "station_to",
        name: "station_to_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "amount",
      },
    },
    {
      label: "Hire Amount",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "amount",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "advance_bhada",
      },
    },
    {
      label: "Advance Paid",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "advance_bhada",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "labour",
      },
    },
    {
      label: "Loading Hamali",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "labour",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "other_charge",
      },
    },
    {
      label: "Extra expense",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "other_charge",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "payable_branch_name",
      },
    },
    {
      label: "Balance Total",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "balance_bhada",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "payable_branch_name",
      },
    },
    {
      label: "Payable Branch",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "payable_branch_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "payable_branch",
        name: "payable_branch_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "owner_name",
      },
    },
    {
      label: "Paid At",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "bhada_paid_branch_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "payable_branch",
        name: "payable_branch_name",
      },
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "owner_name",
      },
    },
  ],
  "group-2": [
    {
      label: "Owner Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "owner_name",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "owner_no",
      },
    },
    {
      label: "Owner Number",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "owner_no",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "driver_name",
      },
    },
    {
      label: "Driver Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "driver_name",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
      },
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "driver_no",
      },
    },
    {
      label: "Driver Number",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "driver_no",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "license_no",
      },
    },
    {
      label: "Driver License No",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "license_no",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "loaded_by",
      },
    },
    {
      label: "Loaded By",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "loaded_by",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "remarks",
      },
    },
    {
      label: "Remarks",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "remarks",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "challan_no",
      },
    },
  ],
};

const defaulGroupInfo = {
  "group-1": [
    {
      label: "Vehicle No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "vehicle_no",
      type: "text",
      placeHolder: "1234",
      apiConfigKey: "getVehicleSuggestions",
      url: SERVER_URL + "/vehicle/",
      suggestionKeyword: "vehicle_no",
      suggestionKeywordForFetchApiArgs: "vehicle_no",
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
        tds_rate: "tds_rate",
      },
      suggestionChooseQueryKeyword: "vehicle_no",
      apiCallRequiredOnGetValue: true,
      keyboardNavigationMap: {
        Enter: "station_from_name",
      },
      toValidate: true,
      valueVerificationFromSuggestionNeeded: true,
      valueVerificationCompulsionField: "vehicle_id",
    },
    {
      label: "Station From",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_from_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "station_from",
        name: "station_from_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "station_to_name",
      },
    },
    {
      label: "Station To",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_to_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "station_to",
        name: "station_to_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "amount",
      },
    },
    {
      label: "Amount",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "amount",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "advance_bhada",
      },
    },
    {
      label: "Advance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "advance_bhada",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "owner_name",
      },
    },
    {
      label: "Balance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "balance_bhada",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "tds_amount",
      },
    },
    {
      label: "Tds Amount",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "tds_amount",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "net_balance",
      },
    },
    {
      label: "Net Balance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "net_balance",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "owner_name",
      },
    },
  ],
  "group-2": [
    {
      label: "Owner Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "owner_name",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "driver_name",
      },
    },
    {
      label: "Driver Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "driver_name",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
      },
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "remarks",
      },
    },
    {
      label: "Remarks",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "remarks",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "payable_branch_name",
      },
    },
    {
      label: "Payable Branch",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "payable_branch_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "payable_branch",
        name: "payable_branch_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "challan_no",
      },
    },
    {
      label: "Paid At",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "bhada_paid_branch_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "payable_branch",
        name: "payable_branch_name",
      },
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "challan_no",
      },
    },
  ],
};

const getGroupInfoBasedOnClient = ()=> {
  if (process.env.REACT_APP_CLIENT == "gdala_log"){
    return gdalaGroupInfo
  } else if (process.env.REACT_APP_CLIENT == "xpress"){
    return xpressGroupInfo
  } else if (process.env.REACT_APP_CLIENT == "guru"){
    return guruGroupInfo
  } else {
    return defaulGroupInfo
  }
}

var groupInfo = getGroupInfoBasedOnClient()

const dataObject = {
  station_from: "",
  station_to: "",
  destination: "",
  station_from_name: "",
  station_to_name: "",
  destination_name: "",
  vehicle_id: "",
  vehicle_no: "",
  created_from: "",
  remarks: "",
  created_by: "",
  challan_ids: [],
  driver_name: "",
  pan_no: "",
  billing_party:"",
  billing_party_name:"",
  owner_name: "",
  trip_no: "",
  status: "",
  loaded_by: "",
  license_no: "",
  owner_no: "",
  driver_no: "",
  other_charge: "0",
  labour: "0",
  amount: "0",
  advance_bhada: "0",
  extra_charge: "0",
  detention_charge: "0",
  shortage_charge: "0",
  other_deduction_charge: "0",
  balance_bhada: "0",
  No: "",
  input_date: formatDate(new Date()),
  last_trip_no: "",
  payable_branch: "0",
  payable_branch_name: "",
  bhada_paid_branch_name: "",
  tds_rate: "",
  tds_amount: "0",
  net_balance: "0",
};

const defaultTripChallanTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Challan No.", className: "text-center table-header" },
  { label: "Challan Date", className: "text-center table-header" },
  { label: "Station From", className: "text-center table-header" },
  { label: "Station To", className: "text-center table-header" },
  { label: "Total Pkgs", className: "text-center table-header" },
  { label: "Created From", className: "text-center table-header" },
  { label: "Created By", className: "text-center table-header" },
];

const guruTripChallanTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Challan No.", className: "text-center table-header" },
  { label: "Challan Date", className: "text-center table-header" },
  { label: "Station From", className: "text-center table-header" },
  { label: "Station To", className: "text-center table-header" },
  { label: "Total Pkgs", className: "text-center table-header" },
  { label: "Total To Pay", className: "text-center table-header" },
  { label: "Total Paid", className: "text-center table-header" },
  { label: "Total To Be Billed", className: "text-center table-header" },
  { label: "Total PF", className: "text-center table-header" },
  { label: "Created From", className: "text-center table-header" },
  { label: "Created By", className: "text-center table-header" },
];

const gdalalTripChallanTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Challan No.", className: "text-center table-header" },
  { label: "Challan Date", className: "text-center table-header" },
  { label: "Station From", className: "text-center table-header" },
  { label: "Station To", className: "text-center table-header" },
  { label: "Total Pkgs", className: "text-center table-header" },
  { label: "Total To Pay", className: "text-center table-header" },
  { label: "Total Paid", className: "text-center table-header" },
  { label: "Total To Be Billed", className: "text-center table-header" },
  { label: "Created From", className: "text-center table-header" },
  { label: "Created By", className: "text-center table-header" },
];

const guruTripChallanTableItems = [
  {
    type: "text",
    name: "booking_chalan_no",
    label: "Bilty No",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "booking_chalan_date",
    label: "Bilty Date",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_from_name",
    label: "Station From",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_to_name",
    label: "Station To",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "total_pkgs",
    label: "Total Pkgs",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "total_to_pay",
    label: "Total To Pay",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "total_paid",
    label: "Total Paid",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "total_to_be_billed",
    label: "Total To Be Billed",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "total_pf",
    label: "Total PF",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "created_from_name",
    label: "Created From",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "created_by_name",
    label: "Created By",
    className: "form-control-medlarge-col",
  },
];

const gdalalTripChallanTableItems = [
  {
    type: "text",
    name: "booking_chalan_no",
    label: "Bilty No",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "booking_chalan_date",
    label: "Bilty Date",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_from_name",
    label: "Station From",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_to_name",
    label: "Station To",
    className: "form-control-large-col",
  },
  // {
  //   type: "text",
  //   name: "destination_name",
  //   label: "Destination",
  //   className: "form-control-large-col",
  // },
  {
    type: "text",
    name: "total_pkgs",
    label: "Total Pkgs",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "total_to_pay",
    label: "Total To Pay",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "total_paid",
    label: "Total Paid",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "total_to_be_billed",
    label: "Total To Be Billed",
    className: "form-control-medlarge-col",
  },
  //   {
  //     type: "text",
  //     name: "pay_type",
  //     label: "Pay Type",
  //     className: "form-control-small-col",
  //   },
  //   {
  //     type: "text",
  //     name: "consignor_name",
  //     label: "Consignor Name",
  //     className: "form-control-medium-col",
  //   },
  //   {
  //     type: "text",
  //     name: "consignor_gst",
  //     label: "Consignor Gst",
  //     className: "form-control-medium-col",
  //   },
  //   {
  //     type: "text",
  //     name: "consignee_name",
  //     label: "Consignee Name",
  //     className: "form-control-medium-col",
  //   },
  //   {
  //     type: "text",
  //     name: "consignee_gst",
  //     label: "Consignee Gst",
  //     className: "form-control-medium-col",
  //   },
  //   {
  //     type: "text",
  //     name: "no_of_package",
  //     label: "No Of Package",
  //     className: "form-control-small-col",
  //   },
  //   {
  //     type: "text",
  //     name: "actual_weight",
  //     label: "Actual Weight",
  //     className: "form-control-small-col",
  //   },
  //   {
  //     type: "text",
  //     name: "charge_weight",
  //     label: "Charge Weight",
  //     className: "form-control-small-col",
  //   },
  //   {
  //     type: "text",
  //     name: "packing_type",
  //     label: "Packing Type",
  //     className: "form-control-large-col",
  //   },
  //   {
  //     type: "text",
  //     name: "private_marka_no",
  //     label: "Private Marka No",
  //     className: "form-control-small-col",
  //   },
  //   {
  //     type: "text",
  //     name: "goods_invoice_value",
  //     label: "Goods Invoice Value",
  //     className: "form-control-small-col",
  //   },
  //   {
  //     type: "text",
  //     name: "delivery_dest_type",
  //     label: "Delivery Dest Type",
  //     className: "form-control-small-col",
  //   },
  //   {
  //     type: "text",
  //     name: "remarks",
  //     label: "Remarks",
  //     className: "form-control-medium-col",
  //   },
  //   {
  //     type: "text",
  //     name: "bilty_charge",
  //     label: "Bilty Charge",
  //     className: "form-control-small-col",
  //   },
  //   {
  //     type: "text",
  //     name: "other_amount",
  //     label: "Other Amount",
  //     className: "form-control-small-col",
  //   },
  //   {
  //     type: "text",
  //     name: "freight",
  //     label: "Freight",
  //     className: "form-control-small-col",
  //   },
  //   {
  //     type: "text",
  //     name: "hamali",
  //     label: "Hamali",
  //     className: "form-control-small-col",
  //   },
  //   {
  //     type: "text",
  //     name: "door_del_charge",
  //     label: "Door Del Charge",
  //     className: "form-control-small-col",
  //   },
  {
    type: "text",
    name: "created_from_name",
    label: "Created From",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "created_by_name",
    label: "Created By",
    className: "form-control-medlarge-col",
  },
];

const defaultTripChallanTableItems = [
  {
    type: "text",
    name: "booking_chalan_no",
    label: "Bilty No",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "booking_chalan_date",
    label: "Bilty Date",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_from_name",
    label: "Station From",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_to_name",
    label: "Station To",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "total_pkgs",
    label: "Total Pkgs",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "created_from_name",
    label: "Created From",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "created_by_name",
    label: "Created By",
    className: "form-control-medlarge-col",
  },
];

function validate(values) {
  let errors = {};

  function validator(value, regexp) {
    var regex = new RegExp(regexp);
    if (values.hasOwnProperty(value)) {
      if (!values[value].trim()) {
        errors[value] = "Required Field";
      } else if (!regex.test(values[value])) {
        errors[value] = "Validation Error";
      } else {
        errors[value] = "";
      }
    }
  }
  for (let group_name of groupNames) {
    for (let i = 0; i < groupInfo[group_name].length; i++) {
      let field_object = groupInfo[group_name][i];
      if (field_object.toValidate) {
        validator(field_object.name, field_object.regExpValidation);
      }
    }
  }
  return errors;
}

const getTableHeaderBasedOnClient = ()=> {
  if (process.env.REACT_APP_CLIENT == "gdala_log"){
    return gdalalTripChallanTableHeader
  }
  else if (process.env.REACT_APP_CLIENT == "guru"){
    return guruTripChallanTableHeader
  }
  else {
    return defaultTripChallanTableHeader
  }
}

const getTableItemBasedOnClient = ()=> {
  if (process.env.REACT_APP_CLIENT == "gdala_log"){
    return gdalalTripChallanTableItems
  }
  else if (process.env.REACT_APP_CLIENT == "guru"){
    return guruTripChallanTableItems
  }
  else {
    return defaultTripChallanTableItems
  }
}

var tripChallanTableHeader = getTableHeaderBasedOnClient()
var tripChallanTableItems = getTableItemBasedOnClient()

const popupInfo = {
  "success_header": "Trip Saving Successful ",
  "error_header": "Error In Trip Module ",
  "success_title": "Trip is successfully created with the following info:-",
  "field_label_success": "Trip No.",
  "field_name_success": "trip_no",
  "error_title": "Error in Trip module with the following info:-",
  "field_label_error": "Error:"
}

export {
  groupInfo,
  groupNames,
  dataObject,
  tripChallanTableHeader,
  tripChallanTableItems,
  validate,
  popupInfo
};
